export function addSuggestedItems(suggestedItems) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_SUGGESTED_ITEMS',
                payload: suggestedItems
            });
            resolve(true)
        });
    }
};

export const resetSuggestedItems = () => ({
    type: 'RESET_SUGGESTED_ITEMS'
});